import { z } from 'zod';
import { uuidSchema } from './common';

export const cardTypeSchema = z.enum(['income', 'expense', 'benefit', 'todo', 'appointment']);
export type CardType = z.infer<typeof cardTypeSchema>;

export const cardColorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'HEX renk gerekli');

export const createCardSchema = z.object({
  title: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
  type: cardTypeSchema,
  color: cardColorSchema.optional(),
  autoRepeat: z.boolean().optional().default(false),
  // `isBalanceCarryover` bilinçli olarak YOK: devir kartını yalnız sunucunun devir akışı
  // üretir; kullanıcıya açık bayrak devir zincirini kırıyordu (V1-4). Gönderilirse zod
  // bilinmeyen anahtar olarak atar, sunucu da okumaz.
  skipNextPeriod: z.boolean().optional().default(false),
  cardTemplateId: uuidSchema.optional(),
  sortOrder: z.number().int().optional(),
  benefitExpiresAt: z.string().datetime().optional(),
  benefitExpectedLoadDay: z.number().int().min(1).max(31).optional(),
  benefitExpectedLoadAmount: z
    .string()
    .regex(/^\d+(\.\d{1,2})?$/)
    .optional(),
  moneyAccountId: uuidSchema.optional(),
  /** Zero-based budgeting: bu kategoriye atanan tutar (yalnızca method='zero_based'). */
  allocatedAmount: z
    .string()
    .regex(/^\d+(\.\d{1,2})?$/, 'Geçerli tutar girin')
    .nullable()
    .optional(),
});
export type CreateCardInput = z.infer<typeof createCardSchema>;

export const updateCardSchema = createCardSchema.partial();
export type UpdateCardInput = z.infer<typeof updateCardSchema>;

/**
 * Zero-based view response — frontend için derlenmiş kategori bazlı özet.
 * Backend `getZeroBasedView(periodId, userId)` döner.
 */
export const zeroBasedCategorySchema = z.object({
  cardId: uuidSchema,
  title: z.string(),
  type: cardTypeSchema,
  color: z.string().nullable(),
  allocated: z.string(),
  spent: z.string(),
  available: z.string(),
  isOverspent: z.boolean(),
});
export type ZeroBasedCategory = z.infer<typeof zeroBasedCategorySchema>;

export const updateAllocationSchema = z.object({
  allocatedAmount: z
    .string()
    .regex(/^\d+(\.\d{1,2})?$/, 'Geçerli tutar girin')
    .nullable(),
});
export type UpdateAllocationInput = z.infer<typeof updateAllocationSchema>;

export const reorderCardsSchema = z.object({
  cardIds: z.array(uuidSchema).min(1),
});
export type ReorderCardsInput = z.infer<typeof reorderCardsSchema>;

export const carryoverBalanceSchema = z.object({
  targetCardId: uuidSchema.optional(),
  note: z.string().max(500).optional(),
});
export type CarryoverBalanceInput = z.infer<typeof carryoverBalanceSchema>;

export const benefitLoadSchema = z.object({
  amount: z.string().regex(/^\d+(\.\d{1,2})?$/, 'Geçerli tutar girin'),
  loadedAt: z.string().datetime().optional(),
  note: z.string().max(500).optional(),
});
export type BenefitLoadInput = z.infer<typeof benefitLoadSchema>;
